<label 
  class="uploadDoc_fund" 
  [class.has-file]="!!fileName"
  [class.invalid]="invalid"
  [class.disabled]="disabled">
  <i class="ri-file-upload-line"></i>
  <input 
    hidden 
    type="file" 
    [accept]="accept" 
    [disabled]="disabled"
    (change)="onFileChange($event)">
  <span class="uploadDoc_text">
    <p class="uploadDoc_label">{{ label }}</p>
    <p class="uploadDoc_fileName" *ngIf="fileName">{{ fileName }}</p>
  </span>
</label>
